<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="report col">
        <div class="d-flex justify-content-end mb-3">
           <!-- New filter button and search form start -->
           <div class="col d-flex gap-2 justify-content-end right-margin">
            <button class="btn btn-primary btn-sm allCategories dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <span>{{ searchConcept }}</span>
            </button>
            
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item mt-1" href="#" @click="setSearchFilter('All Categories')">All Categories</a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(searchColumns, index) in columns.search" :key="index">
                <a class="dropdown-item mt-1" href="#" @click="setSearchFilter(searchColumns)">{{ searchColumns.label }}</a>
              </li>
            </ul>
            <form class="search-form" @submit.prevent="performSearch">
              <input id="searchBar" class="form-control srchip" v-model="searchQuery" @input="handleInputs"
                type="search" placeholder="" aria-label="Search" />
              <input class="btn btn-outline-dark searchbutton" type="submit" value="Search" @click="searchWithQuery()" />
            </form>
            <button class="clear-filter-icon filter-icon-button" @click="clearFilters">
              <img src="../../assets/icons/clear-filter-icon.svg" alt="filter-icon" class="filter-icon" />
            </button>
          </div>
          <!-- New filter button and search form end -->
          <button class="btn-eye" @click="toggleGridVisibility" data-bs-toggle="tooltip"
            title="Toggle Grid Visibility"></button>
          <!-- AI button: positioned near download button -->
          <button 
             v-if="tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS' && tableProps.type !== 'mapper.activities' && tableProps.type === 'mapper.component' && tableProps.type !== 'mapper.Process_Details'" 
            @click="showAIModal"
            class="btn-ai" 
            title="Generate Prompts"
            :disabled="selectedRows.length === 0"
            :class="{ 'disabled': selectedRows.length === 0 }"
          > 
          </button>
          <!-- AI button: positioned near download button -->
          <!-- <button 
            v-if="tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS' && tableProps.type !== 'mapper.activities' && tableProps.type === 'mapper.component' && tableProps.type !== 'mapper.Process_Details'" 
            @click="showOrchestrationModal"
            class="btn-orchestration" 
            title="Orchestration Generation"
            :disabled="selectedRows.length === 0"
            :class="{ 'disabled': selectedRows.length === 0 }"
          > 
          </button> -->
          <!-- Download button: hide for mapping jobs tab -->
          <button
            v-if="tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS'"
            @click="downloadData"
            class="download-button"
            >
            <i class="fas fa-cloud-download fa-sm"></i>
          </button>
          <button type="button" class="btn btn-primary column-button dropdown-toggle" data-bs-toggle="dropdown" :aria-expanded="false">
            Columns
          </button>
          <ul class="dropdown-menu fade">
            <li>
              <a class="dropdown-item" href="#">
                <label>
                  <input type="checkbox" :value="'*'" v-model="selectAll" @change="handleSelectAll" />
                  Select All
                </label>
              </a>
            </li>
            <hr class="dropdown-divider" />
            <li v-for="(column, index) in tableConfigs" :key="index">
              <a class="dropdown-item" href="#">
                <label>
                  <input type="checkbox" :value="column.name" :disabled="column.checked" v-model="selectedColumns"
                    @change="handleColumnChange(column.name)" />
                  {{ column.label }}
                </label>
              </a>
            </li>
          </ul>
        </div>
        <div class="table-responsive full-height" v-if="tableVisible">
          <!-- Loading overlay: only show if loading and showLoader are true -->
          <div v-if="loading && showLoader">
            <Loading />
          </div>
          <table class="table table-hover table-borderless custom-table">
            <thead>
              <tr>
                <!-- Only show checkbox column for Use Cases tab -->
                <th v-if="tableProps.type === 'mapper.component'" class="align-middle table-header-sticky" style="width: 40px; text-align: center;">
                  <input 
                    type="checkbox" 
                    :checked="isAllSelected"
                    @change="toggleSelectAll($event)"
                    class="form-check-input"
                    ref="selectAllCheckbox"
                  />
                </th>
                <th 
                  v-for="(header, index) in selectedConfigs" 
                  :key="index" 
                  scope="col"
                  class="align-middle table-header-sticky"
                  :style="{
                    textAlign: header.headerTextAlign || header.textAlign || 'center',
                    minWidth: header.name === 'process' ? '210px' : undefined // Increase width for process column
                  }"
                  @mouseover="hoveredColumn = index"
                  @mouseleave="hoveredColumn = ''"
                  @click="header.isSortable && sort(header.name, header.label, index)">
                  <div>
                    {{ header.label }}
                  </div>
                  <div v-if="header.isSortable && (hoveredColumn === index || sortColumn === index)" class="sort-buttons">
                    <button class="svg-button" v-if="isDescending">
                      <svg class="svg-icon"
                        style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;"
                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123.392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z" />
                      </svg>
                    </button>
                    <button class="svg-button" v-if="!isDescending">
                      <svg class="svg-icon"
                        style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;"
                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M573.056 272l308.8 404.608A76.8 76.8 0 0 1 820.736 800H203.232a76.8 76.8 0 0 1-61.056-123.392L450.976 272a76.8 76.8 0 0 1 122.08 0z" />
                      </svg>
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecordFound">
                <td class="h4" :colspan="tableProps.type === 'mapper.component' ? selectedConfigs.length + 1 : selectedConfigs.length">No records found!</td>
              </tr>
              <template v-else>
                <template v-for="(transaction, transactionIndex) in reportTransactions" :key="getUniqueIDValue(transaction)">
                  <tr>
                    <!-- Only show checkbox column for Use Cases tab -->
                    <td v-if="tableProps.type === 'mapper.component'" class="align-middle" style="text-align: center;">
                      <input 
                        type="checkbox" 
                        :checked="selectedRows.includes(getUniqueIDValue(transaction))"
                        @change="handleRowSelect($event, transaction)"
                        class="form-check-input"
                      />
                    </td>
                    <td v-for="column in selectedConfigs" :key="column.name"
                        :style="getTextAlignmentStyle(transaction, column)" class="align-middle">
                      <!-- Dropdown icon for Use Case and Process columns only in Process Details tab -->
                      <template v-if="(column.name === 'process') && tableProps.type === 'mapper.Process_Details'">
                        <div style="display: flex; align-items: center; position: relative;">
                          <span
                            v-if="column.name === 'process'"
                            class="btn-mermaid"
                            @click="fetchGraphData(transaction)"
                            style="font-size: inherit; cursor: pointer;"
                          >
                            <template v-if="shouldTruncate(column.label, getTableData(transaction, column), 25)">
                              {{ truncateText(getTableData(transaction, column), 25) }}
                              <a v-if="getTableData(transaction, column) && getTableData(transaction, column).length > 25"
                                href="#" @mouseover="showPopover($event, getTableData(transaction, column))" @mouseleave="hidePopover" style="font-size: inherit;">...</a>
                            </template>
                            <template v-else>
                              {{ getTableData(transaction, column) }}
                            </template>
                          </span>
                          <div class="expand-icon-fixed">
                            <button class="btn btn-link p-0" type="button"
                              @click="toggleChildTable(transactionIndex)"
                              aria-expanded="false" style="box-shadow:none;">
                              <!-- Collapse/Expand SVG icon (chevron down) -->
                              <i :class="openChildTableIndex === transactionIndex ? 'fa-sharp fa-solid fa-square-minus' : 'fa-sharp fa-solid fa-square-plus'"></i>
                            </button>
                          </div>
                        </div>
                      </template>
                      <!-- Action column: add download button -->
                      <template v-else-if="column.name === 'action'">
                        <button class="btn btn-download" @click="childDownloadRowData(transaction)" title="Request Download">
                          <i class="fas fa-cloud-download fa-lg"></i>
                        </button>
                      </template>
                      <!-- Existing logic for other columns -->
                      <template v-else>
                        <!-- Show only date for Completed Date and Requested Date -->
                        <template v-if="column.name === 'completedDate' || column.name === 'requestedDate'">
                          <span style="font-size: inherit;">
                            {{ formatDateOnly(getTableData(transaction, column)) }}
                          </span>
                        </template>
                        <template v-else>
                          <div v-if="shouldTruncate(column.label, getTableData(transaction, column))">
                            <span v-if="(tableProps.type === 'mapper.component' || tableProps.type === 'mapper.Process_Details') && column.name === 'process'" 
                                  @click="fetchGraphData(transaction)" class="btn-mermaid">
                              {{ truncateText(getTableData(transaction, column), 25) }}
                            </span>
                            <span v-else style="font-size: inherit;">
                              {{ truncateText(getTableData(transaction, column), 25) }}
                            </span>
                            <a href="#" @mouseover="showPopover($event, getTableData(transaction, column))" @mouseleave="hidePopover" style="font-size: inherit;">...</a>
                          </div>
                          <div v-else>
                            <span v-if="(tableProps.type === 'mapper.component' || tableProps.type === 'mapper.Process_Details') && column.name === 'process'" 
                                  @click="fetchGraphData(transaction)" class="btn-mermaid">
                              {{ getTableData(transaction, column) }}
                            </span>
                            <span v-else style="font-size: inherit;">
                              {{ getTableData(transaction, column) }}
                            </span>
                          </div>
                        </template>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="openChildTableIndex === transactionIndex">
                    <td :colspan="tableProps.type === 'mapper.component' ? selectedConfigs.length + 1 : selectedConfigs.length" style="padding:0; background:#f9f9f9;">
                      <!-- Pass collapsed prop and listen for collapse event -->
                      <ChildActivities
                        ref="childActivities"
                        :key="(transaction.process && transaction.process.activities ? transaction.process.activities.length : 0) + '-' + openChildTableIndex"
                        :activities="Array.isArray(transaction.process && transaction.process.activities) ? transaction.process.activities : []"
                        :collapsed="openChildTableIndex !== transactionIndex"
                        @collapse="handleChildCollapse"
                      />
                      <!-- Debug log -->
                      <span style="display:none">{{ console.log('ChildActivities activities:', transaction.process && transaction.process.activities) }}</span>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination-bar" v-if="!noRecordFound">
          <Pagination :totalPages="totalPages" :perPage="pageSize" :currentPage="currentPage"
            :totalRecords="totalRecords" @pagechanged="onPageChange" @recordCount="onRecordChange" />
        </div>
      </div>
    </div>
    
    <!-- AI Code Generation Modal -->
    <div v-if="showAIPopup" class="modal-overlay" @click="closeAIModal">
      <div class="ai-modal-content" @click.stop>
        <div class="modal-header">
          <h3>AI Prompt Generation</h3>
          <button class="close-button" @click="closeAIModal">&times;</button>
        </div>
        <div class="modal-body">
          <!-- <p>Generate code for selected use cases using AI.</p> -->
          
          <!-- <div class="selected-items">
            <h4>Selected Items: {{ selectedRows.length }}</h4>
            <div v-if="selectedRows.length === 0" class="no-selection">
              <p class="warning-text">⚠️ Please select at least one row to generate code.</p>
            </div>
            <div v-else class="selection-list">
              <ul>
                <li v-for="rowId in selectedRows.slice(0, 5)" :key="rowId">
                  {{ getRowDisplayName(rowId) }}
                </li>
                <li v-if="selectedRows.length > 5" class="more-items">
                  ... and {{ selectedRows.length - 5 }} more items
                </li>
              </ul>
            </div>
          </div> -->
          
          <div class="options-section">
            <!-- <h4>Options:</h4> -->
            <div class="checkbox-group">
              <label>
                <input type="checkbox" v-model="aiOptions.isAvroRequired" />
                Include Avro Schema
              </label>
            </div>
          </div>
          
          <!-- Language Selection Section -->
          <div class="options-section">
            <div class="radio-group">
              <h4>Language</h4>
              <label class="radio-label">
                <input 
                  type="radio" 
                  name="language" 
                  value="Python" 
                  v-model="aiOptions.language"
                />
                <span class="radio-text">Python</span>
              </label>
              <label class="radio-label disabled">
                <input 
                  type="radio" 
                  name="language" 
                  value="Java" 
                  v-model="aiOptions.language"
                  disabled
                />
                <span class="radio-text">Java</span>
              </label>
              <label class="radio-label disabled">
                <input 
                  type="radio" 
                  name="language" 
                  value="C#" 
                  v-model="aiOptions.language"
                  disabled
                />
                <span class="radio-text">C#</span>
              </label>
            </div>
          </div>
          
          <!-- AI Engine Selection Section -->
          <div class="options-section">
            <div class="radio-group">
              <h4>LLM</h4>
              <label class="radio-label">
                <input 
                  type="radio" 
                  name="aiEngine" 
                  value="Claude Sonnet 4" 
                  v-model="aiOptions.aiEngine"
                />
                <span class="radio-text">Claude Sonnet 4</span>
              </label>
              <label class="radio-label disabled">
                <input 
                  type="radio" 
                  name="aiEngine" 
                  value="ChatGPT 4.1" 
                  v-model="aiOptions.aiEngine"
                  disabled
                />
                <span class="radio-text">ChatGPT 4.1</span>
              </label>
            </div>
          </div>
          
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeAIModal">Cancel</button>
          <button 
            class="btn-generate" 
            @click="generateCode" 
            :disabled="selectedRows.length === 0"
            :class="{ disabled: selectedRows.length === 0 }"
          >
            Generate Prompts
          </button>
        </div>
      </div>
    </div>

    <!-- Orchestration Code Generation Modal -->
    <div v-if="showOrchestrationPopup" class="modal-overlay" @click="closeOrchestrationModal">
      <div class="ai-modal-content" @click.stop>
        <div class="modal-header">
          <h3>Orchestration Generation</h3>
          <button class="close-button" @click="closeOrchestrationModal">&times;</button>
        </div>
        <div class="modal-body">
          <!-- Language Selection Section - Only Java enabled -->
          <div class="options-section">
            <div class="radio-group">
              <h4>Language</h4>
              <label class="radio-label">
                <input 
                  type="radio" 
                  name="orchestrationLanguage" 
                  value="java" 
                  v-model="orchestrationOptions.language"
                />
                <span class="radio-text">Java</span>
              </label>
              <label class="radio-label disabled">
                <input 
                  type="radio" 
                  name="orchestrationLanguage" 
                  value="Python" 
                  v-model="orchestrationOptions.language"
                  disabled
                />
                <span class="radio-text">Python</span>
              </label>
              <label class="radio-label disabled">
                <input 
                  type="radio" 
                  name="orchestrationLanguage" 
                  value="C#" 
                  v-model="orchestrationOptions.language"
                  disabled
                />
                <span class="radio-text">C#</span>
              </label>
            </div>
          </div>

          <!-- Questions Table -->
          <div class="questions-section">
            <table class="questions-table">
              <tbody>
                <tr>
                  <td>
                    Would you like to migrate EMS/JMS to Kafka ?<br>
                    <small style="color: #666; font-style: italic;">(Selecting "No" will convert TIBCO EMS → Java EMS and TIBCO JMS → Java JMS)</small>
                  </td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="migrateEmsJms" 
                          value="Yes" 
                          v-model="orchestrationOptions.migrateEmsJms"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="migrateEmsJms" 
                          value="No" 
                          v-model="orchestrationOptions.migrateEmsJms"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Would you like to include AVRO Schema ?</td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="includeAvroSchema" 
                          value="Yes" 
                          v-model="orchestrationOptions.includeAvroSchema"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="includeAvroSchema" 
                          value="No" 
                          v-model="orchestrationOptions.includeAvroSchema"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    Would you like to migrate SOAP APIs to REST ?<br>
                    <small style="color: #666; font-style: italic;">(Selecting "No" will convert TIBCO SOAP APIs to Java-based SOAP APIs)</small>
                  </td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="migrateSoapToRest" 
                          value="Yes" 
                          v-model="orchestrationOptions.migrateSoapToRest"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="migrateSoapToRest" 
                          value="No" 
                          v-model="orchestrationOptions.migrateSoapToRest"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Would you like to persist workflow history and metrics?</td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="persistWorkflowHistory" 
                          value="Yes" 
                          v-model="orchestrationOptions.persistWorkflowHistory"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input 
                          type="radio" 
                          name="persistWorkflowHistory" 
                          value="No" 
                          v-model="orchestrationOptions.persistWorkflowHistory"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeOrchestrationModal">Cancel</button>
          <button 
            class="btn-generate" 
            @click="generateOrchestrationCode" 
            :disabled="selectedRows.length === 0"
            :class="{ disabled: selectedRows.length === 0 }"
          >
            Generate Code
          </button>
        </div>
      </div>
    </div>
    
    <FooterView />
  </div>
</template>

<script>
import { getCookie } from "../../store/cookie.js";
import { makeOpearationRequest } from "@/services/apiServices";
import Pagination from '../Pagination.vue';
import { user } from "../../utils/util.js";
import { changeFileExtension, formatDateConsistent } from "@/utils/util.js";
import { toast } from "vue3-toastify";
import { Popover } from 'bootstrap';
import Loading from '../Loading.vue';
import FooterView from "@/views/FooterView.vue";
import ChildActivities from "@/views/ChildActivities.vue";

export default {
  name: "ViewTemplate",
  props: ["tableProps", "projectParamId", "mapperParamId"],
  data() {
    return {
      selectedConfigs: {},
      loading: false,
      showLoader: true,
      selectedRows: [],
      tableConfigs: this.tableProps.configs,
      selectedColumns: this.tableProps.configs
        .filter(column => column.defaultSelected)
        .map(column => column.name),
      selectAll: false, // will be set in mounted
      currentPage: 1,
      pageSize: 20,
      totalPages: 5,
      reportTransactions: [],
      totalRecords: 0,
      noRecordFound: false,
      sortColumn: this.getDefaultSortColumnIndex(),
      filterSortColumn: this.tableProps.defaultSortColumn || { name: 'defaultColumn' }, // Def
      filterSortOrder: this.tableProps.defaultSortOrder || { name: 'asc' }, // Default sort order
      tableVisible: true,
      hoveredColumn: "",
      isDescending: true,
      searchConcept: 'All Categories',
      searchQuery: "",
      columns: {
        default: {},
        sort: {},
        search: {}
      },
      showModal: false,
      modalTitle: '',
      modalContent: '',
      openChildTableIndex: null, // <-- track which parent row is open
      selectedChildRows: [],
      childActivitiesCache: {}, // cache for child activities by processId
      showAIPopup: false, // AI modal visibility
      aiOptions: {
        isAvroRequired: false,
        language: 'Python',
        aiEngine: 'Claude Sonnet 4'
      },
      showOrchestrationPopup: false, // Orchestration modal visibility
      orchestrationOptions: {
        language: 'java',
        migrateEmsJms: 'No',
        includeAvroSchema: 'No',
        migrateSoapToRest: 'No',
        persistWorkflowHistory: 'No'
      },
    };
  },
  inject: ['toggleMapperTabs'],
  components: {
    Pagination,
    Loading,
    FooterView,
    ChildActivities
  },
  async mounted() {
    this.refresh();
    this.updateSelectedConfigs();
    this.view();
    this.columns.search = this.tableConfigs
      .filter((item) => item.search != false)
      .map(({ name, label }) => ({ name, label }));
    // Set selectAll if all columns are selected by default
    this.selectAll = this.selectedColumns.length === this.tableConfigs.length;
  },
  computed: {
    allRowIds() {
      return this.reportTransactions.map(transaction => this.getUniqueIDValue(transaction));
    },
    isAllSelected: {
      get() {
        // Only calculate for Use Cases tab
        if (this.tableProps.type !== 'mapper.component') {
          return false;
        }
        return this.reportTransactions.length > 0 && 
               this.selectedRows.length === this.reportTransactions.length;
      },
      set(value) {
        // Only allow selection for Use Cases tab
        if (this.tableProps.type !== 'mapper.component') {
          return;
        }
        if (value) {
          this.selectedRows = [...this.allRowIds];
        } else {
          this.selectedRows = [];
        }
      }
    }
  },
  methods: {
    toggleSelectAll(event) {
      // Only allow for Use Cases tab
      if (this.tableProps.type !== 'mapper.component') {
        return;
      }
      if (event.target.checked) {
        this.selectedRows = [...this.allRowIds];
      } else {
        this.selectedRows = [];
      }
    },
    handleRowSelect(event, transaction) {
      // Only allow for Use Cases tab
      if (this.tableProps.type !== 'mapper.component') {
        return;
      }
      const rowId = this.getUniqueIDValue(transaction);
      console.log('Row selection changed:', { rowId, checked: event.target.checked, currentSelection: this.selectedRows });
      
      if (event.target.checked) {
        // Add to selection if not already selected
        if (!this.selectedRows.includes(rowId)) {
          this.selectedRows = [...this.selectedRows, rowId];
          console.log('Added to selection. New selection:', this.selectedRows);
        }
      } else {
        // Remove from selection
        this.selectedRows = this.selectedRows.filter(id => id !== rowId);
        console.log('Removed from selection. New selection:', this.selectedRows);
      }
    },
    async view() {
      this.loading = true;
      // Only show loader if showLoader is true (showLoader is set to true for non-sort actions)
      let searchValues = { queryValue: this.searchQuery.trim() };
      if (this.searchName != "") {
        searchValues = { ...searchValues, ...{ queryColumn: this.searchName } };
      }
      const sortField = (this.tableProps.type === "mapper.MAPPER_MAPPING_JOBS")
        ? "requestedDate"
        : (this.tableProps.type !== "mapper.usage" && this.tableProps.type !== "mapper.activities" && this.tableProps.type !== "mapper.component" && this.tableProps.type !== "mapper.Process_Details"
            ? (this.filterSortColumn.name.toLowerCase() === 'usecase' ? 'usecase' 
              : this.filterSortColumn.name.toLowerCase() === 'process' ? 'usecase,process' 
              : `usecase,process,${this.filterSortColumn.name}`)
            : this.filterSortColumn.name);
      let payload = {
        userId: getCookie(user.id),
        type: this.tableProps.type,
        requestId: this.projectParamId,
        mapperId: this.mapperParamId,
        sort: {
          field: sortField,
          order: this.filterSortOrder.name,
        },
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      if (searchValues != null) {
        payload = { ...payload, ...searchValues };
      }
      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/view", payload);
        if (response.status === 200) {
          this.reportTransactions = response.data.transactions;
          console.log("Report transactions:", this.reportTransactions);
          this.noRecordFound = this.reportTransactions.length === 0;
          this.totalRecords = response.data.totalRecords;
          console.log("Response data:", response.data);
          this.totalPages = Math.ceil(response.data.totalRecords / this.pageSize);
        } else {
          this.noRecordFound = false;
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        this.noRecordFound = true;
      } finally {
        this.loading = false;
        this.showLoader = false; // reset after each view
      }
    },
    toggleGridVisibility() {
      this.toggleMapperTabs()
    },
    handleSelectAll() {
      if (this.selectAll) {
        this.selectedColumns = this.tableConfigs.map(column => column.name);
      } else {
        this.selectedColumns = this.tableConfigs
          .filter(column => column.defaultSelected)
          .map(column => column.name);
      }
      this.updateSelectedConfigs();
      this.view();
    },
    handleColumnChange(value) {
      this.selectAll = this.selectedColumns.length === this.tableConfigs.length;
      this.updateSelectedConfigs();
      this.view();
    },
    updateSelectedConfigs() {
      this.selectedConfigs = this.tableConfigs.filter(column => this.selectedColumns.includes(column.name));
    },
    getUniqueIDValue(transaction) {
      // Define one primary ID field and search case-insensitively
      const primaryIdField = 'id';
      
      // First, try to find the primary ID field (case-insensitive)
      const keys = Object.keys(transaction);
      const idKey = keys.find(key => key.toLowerCase() === primaryIdField.toLowerCase());
      
      if (idKey && transaction[idKey] !== undefined) {
        return transaction[idKey];
      }
      
      // Fallback: try other common ID fields (case-insensitive)
      const fallbackIdFields = ['requestId', 'transactionId'];
      for (const field of fallbackIdFields) {
        const foundKey = keys.find(key => key.toLowerCase() === field.toLowerCase());
        if (foundKey && transaction[foundKey] !== undefined) {
          return transaction[foundKey];
        }
      }
      
      // If no ID field found, create a unique key from multiple fields as a fallback
      if (transaction) {
        return JSON.stringify(transaction);
      }
      
      // Last resort fallback
      return Math.random().toString(36).substr(2, 9);
    },
    async showAIModal() {
      // Check if any rows are selected
      if (this.selectedRows.length === 0) {
        toast.error("Please select at least one row to Generate Prompts.", {
          autoClose: 3000,
        });
        return;
      }
      
      // Call the usecase_ai_enable API when button is clicked
      try {
        const payload = {
          userId: getCookie(user.id),
          projectid: this.projectParamId,
          type: "MAPPER.USECASE_AI_ENABLE"
        };

        console.log("Checking AI enablement with payload:", payload);

        const response = await makeOpearationRequest(this.$acclConfigs, "/usecase_ai_enable", payload);
        
        if (response.status === 200) {
          // Check if AI is enabled based on the API response
          const isAIEnabledForProject = response.data.xsl_status === 'ok' && response.data.schema_status === 'ok' && response.data.mapper_status === 'ok';
          console.log("AI enablement status:", isAIEnabledForProject);
          
          if (!isAIEnabledForProject) {
            toast.error("AI functionality is not enabled for this project.", {
              autoClose: 3000,
            });
            return;
          }
          
          // If AI is enabled, show the modal
          this.showAIPopup = true;
          
        } else {
          toast.error("Failed to check AI enablement. Please try again.", {
            autoClose: 3000,
          });
          console.warn("AI enablement check failed:", response);
        }
      } catch (error) {
        console.error("Error checking AI enablement:", error);
        toast.error("An error occurred while checking AI enablement.", {
          autoClose: 3000,
        });
      }
    },
    async showOrchestrationModal() {
      // Check if any rows are selected
      try {
        const payload = {
          userId: getCookie(user.id),
          projectid: this.projectParamId,
          type: "MAPPER.USECASE_AI_ENABLE"
        };

        console.log("Checking Orchestration enablement with payload:", payload);

        const response = await makeOpearationRequest(this.$acclConfigs, "/usecase_ai_enable", payload);
        
        if (response.status === 200) {
          // Check if orchestration is enabled based on the API response
          const isOrchestrationEnabledForProject =
            response.data.xsl_status === 'ok'  && 
            (response.data.schema_status === 'ok' || response.data.schema_status === 'NA') &&
            response.data.mapper_status === 'ok';
          console.log("Orchestration enablement status:", isOrchestrationEnabledForProject);

          if (!isOrchestrationEnabledForProject) {
            // Show toast with actual status values
            const { xsl_status, schema_status, mapper_status } = response.data;
            toast.error(`Orchestration status:\nXSL: ${xsl_status}\nSchema: ${schema_status}\nMapper: ${mapper_status}`, {
              autoClose: 4000,
            });
            return;
          }

          // If orchestration is enabled, show the orchestration modal
          this.showOrchestrationPopup = true;

        } else {
          toast.error("Failed to check Orchestration enablement. Please try again.", {
            autoClose: 3000,
          });
          console.warn("Orchestration enablement check failed:", response);
        }
      } catch (error) {
        console.error("Error checking Orchestration enablement:", error);
        toast.error("An error occurred while checking Orchestration enablement.", {
          autoClose: 3000,
        });
      }
    },
    closeAIModal() {
      this.showAIPopup = false;
    },
    async generateOrchestrationCode() {
      let toastId = null;
      try {
        toastId = toast.loading("Generating orchestration...");
        const usecasesIds = this.selectedRows.map(rowId => {
          const transaction = this.reportTransactions.find(trans => 
            this.getUniqueIDValue(trans) === rowId
          );
          return transaction?.usecaseIds || transaction?.usecaseId || transaction?.useCase || transaction?.id || rowId;
        });
        const payload = {
          userId: getCookie(user.id),
          usecasesIds: usecasesIds,
          type: "ORCHESTRATION.GENERATE_CODE",
          additional_input: {
            language: this.orchestrationOptions.language,
            migrate_ems_jms_to_kafka: this.orchestrationOptions.migrateEmsJms === 'Yes',
            include_avro_schema: this.orchestrationOptions.includeAvroSchema === 'Yes',
            migrate_soap_to_rest: this.orchestrationOptions.migrateSoapToRest === 'Yes',
            persist_workflow_history: this.orchestrationOptions.persistWorkflowHistory === 'Yes'
          }
        };
        console.log("Generating orchestration with payload:", payload);
        const response = await makeOpearationRequest(this.$acclConfigs, "/generate_orchestration", payload);
        if (response.status === 200) {
          toast.update(toastId, {
            render: "Orchestration generated successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          console.log("Orchestration generation successful:", response.data);
        } else {
          toast.update(toastId, {
            render: "Failed to generate orchestration. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.warn("Orchestration generation failed:", response);
        }
        this.closeOrchestrationModal();
      } catch (error) {
        console.error("Error generating orchestration:", error);
        if (toastId) {
          toast.update(toastId, {
            render: "An error occurred while generating orchestration.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred while generating orchestration.", {
            autoClose: 3000,
          });
        }
        this.closeOrchestrationModal();
      }
    },
    closeOrchestrationModal() {
      this.showOrchestrationPopup = false;
    },
    getRowDisplayName(rowId) {
      // Find the transaction by ID and return a display name
      const transaction = this.reportTransactions.find(trans => 
        this.getUniqueIDValue(trans) === rowId
      );
      
      if (transaction) {
        // Try to get a meaningful display name from common fields
        return transaction.name || 
               transaction.processName || 
               transaction.useCase || 
               transaction.process || 
               transaction.title || 
               `Item ${rowId}`;
      }
      return `Item ${rowId}`;
    },
    async generateCode() {
      // Check if any rows are selected
      if (this.selectedRows.length === 0) {
        toast.error("Please select at least one row to Generate Prompts.", {
          autoClose: 3000,
        });
        return;
      }

      // Close the modal
      this.closeAIModal();

      let toastId = null;
      try {
        // Show loading toast
        toastId = toast.loading("Generating prompts...");
        // Get the selected usecase IDs from selected rows
        const usecasesIds = this.selectedRows.map(rowId => {
          // Find the transaction by ID and extract usecase ID
          const transaction = this.reportTransactions.find(trans => 
            this.getUniqueIDValue(trans) === rowId
          );
          // You may need to adjust this based on your data structure
          // Common field names for usecase ID: 'usecaseIds', 'usecaseId', 'useCase', 'id'
          return transaction?.usecaseIds || transaction?.usecaseId || transaction?.useCase || transaction?.id || rowId;
        });

        const payload = {
          userId: getCookie(user.id),
          usecasesIds: usecasesIds,
          type: "MAPPER.GENERATIVE_CODE",
          additional_input: {
            isAvroRequired: this.aiOptions.isAvroRequired,
            language: this.aiOptions.language.toLowerCase(),
            aiEngine: this.getSimplifiedAiEngine()
          }
        };

        // Configure for blob response (file download)
        const config = {
          responseType: "blob",
        };

        console.log("Generating prompts with payload:", payload);

        const response = await makeOpearationRequest(this.$acclConfigs, "/generative_code", payload, config);
        
        if (response.status === 200) {
          toast.update(toastId, {
            render: "Prompts generated and downloaded successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          
          // Handle the blob response like other download functions
          const blob = new Blob([response.data], { type: response.data.type });
          
          // Retrieve the fileName from response headers
          let fileName = "generated_prompts";
          const contentDisposition = response.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
            }
          }
          
          // Create a link element and trigger the download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = changeFileExtension(fileName, "zip");
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          
        } else {
          toast.update(toastId, {
            render: "Failed to Generate Prompts. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to Generate Prompts:", response);
        }
      } catch (error) {
        console.error("Error generating prompts:", error);
        if (toastId) {
          toast.update(toastId, {
            render: "An error occurred while generating prompts.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred while generating prompts.", {
            autoClose: 3000,
          });
        }
      }
    },
    getTextAlignmentStyle(transaction, column) {
      // Return an object instead of a string
      if (column.textAlign) {
        return { textAlign: column.textAlign };
      } else {
        return { textAlign: 'center' };
      }
    },
    getStylesForStatus(transaction, column, isActionable) {
      return "";
    },
    getTableData(transaction, column) {
      return transaction[column.label];
    },
    refresh() {
      this.showLoader = true; // show loader for non-sort actions
      this.loading = true;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.showLoader = true; // show loader for pagination
      this.refresh();
      this.view();
    },
    onRecordChange(recordSize) {
      this.pageSize = recordSize;
      this.showLoader = true; // show loader for record size change
      this.refresh();
      this.view();
    },
    async downloadData() {
      let toastId = null;
      
      try {
        // Show loading toast
        toastId = toast.loading("Processing download request...", {
          closeOnClick: false,
        });
        
        let payload = {
          userId: getCookie(user.id),
          type: this.tableProps.type,
          requestIds: [this.projectParamId],
        };
        
        const initialResponse = await makeOpearationRequest(this.$acclConfigs, "/download", payload);
        
        if (initialResponse.status === 200 || initialResponse.status === 202) {
          const contentType = initialResponse.headers['content-type'];
          
          if (contentType && contentType.includes('application/json')) {
            const responseData = initialResponse.data;
            
            if (responseData.download_id && responseData.status === 'new') {
              toast.update(toastId, {
                render: `${responseData.message}`,
                type: "info",
                isLoading: false,
                autoClose: 5000,
              });
            } else {
              toast.update(toastId, {
                render: responseData.message || "Download request processed.",
                type: "info",
                isLoading: false,
                autoClose: 4000,
              });
            }
          } else {
            const blobConfig = {
              responseType: "blob",
            };
            
            const blobResponse = await makeOpearationRequest(this.$acclConfigs, "/download", payload, blobConfig);
            
            if (blobResponse.status === 200) {
              toast.update(toastId, {
                render: "File downloaded successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
              });
              
              const blob = new Blob([blobResponse.data], { type: blobResponse.data.type });
              let fileName = "downloaded_file";
              const contentDisposition = blobResponse.headers['content-disposition'];
              if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                  fileName = fileNameMatch[1];
                }
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = changeFileExtension(fileName, "zip");
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            } else {
              toast.update(toastId, {
                render: "Download failed. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
              });
            }
          }
        } else {
          toast.update(toastId, {
            render: "Download failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to fetch data:", initialResponse);
        }
      } catch (error) {
        if (toastId) {
          toast.update(toastId, {
            render: "Download request failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("Download request failed. Please try again.", {
            autoClose: 3000,
          });
        }
        console.error("Failed to fetch data:", error);
      }
    },
    convertToCSV(data) {
      const headers = this.selectedConfigs.map(config => config.label).join(',');
      const rows = data.map(row => {
        return this.selectedConfigs.map(config => {
          const value = row[config.label];
          if (typeof value === 'object' && value !== null) {
            return JSON.stringify(value);
          }
          return value;
        }).join(',');
      }).join('\n');
      return `${headers}\n${rows}`;
    },
    sort(name, label, index) {
      // Do NOT show loader for sorting
      if (this.isDescending) {
        this.sortAscending(name, label, index);
      } else {
        this.sortDescending(name, label, index);
      }
    },
    sortAscending(name, label, index) {
      this.sortColumn = index;
      this.isDescending = false;
      this.updateFilterSortOrder("asc", "Ascending");
      this.handleSortByChange(name, false); // false = don't show loader
    },
    sortDescending(name, label, index) {
      this.sortColumn = index;
      this.isDescending = true;
      this.updateFilterSortOrder("desc", "Descending");
      this.handleSortByChange(name, false); // false = don't show loader
    },
    handleSortByChange(name, showLoader = false) {
      this.filterSortColumn.name = name;
      this.showLoader = showLoader; // will be false for sort
      this.view();
    },
    updateFilterSortOrder(name, label) {
      this.filterSortOrder.name = name;
      this.filterSortOrder.label = label;
    },
    getDefaultSortColumnIndex() {
      const defaultSortColumn = this.tableProps.defaultSortColumn;
      if (!defaultSortColumn || !defaultSortColumn.name) {
        return 0;
      }
      const sortColumnName = defaultSortColumn.name;
      const config = this.tableProps.configs.find(item => item.name === sortColumnName);
      return config ? (config.order > 0 ? config.order - 1 : config.order) : 0;
    },
    handleInputs(event) {
      if (!event.target.value) {
        this.view();
      }
    },
    async searchWithQuery() {
      this.currentPage = 1;
      this.showLoader = true; // show loader for search
      await this.view();
    },
    clearFilters() {
      this.searchName = "";
      this.searchConcept = "All Categories";
      this.searchQuery = "";
      this.showLoader = true; // show loader for clear
      this.view();
    },
    clearUpdatedViews() {
      removeSessionItem(this.tableProps.type + '_columns');
      removeSessionItem(this.tableProps.type + '_view_updated');
    },
    setSearchFilter(filter) {
      if (filter == "All Categories") {
        this.searchConcept = filter;
      } else {
        this.searchConcept = filter.label;
      }
      this.searchName = filter.name;
    },
    showPopover(event, content) {
      const popover = new Popover(event.target, {
        content: content,
        trigger: 'hover',
        placement: 'auto',
        container: 'body',
        boundary: 'viewport',
        fallbackPlacements: ['top', 'bottom', 'left', 'right']
      });
      popover.show();
    },
    hidePopover(event) {
      const popover = Popover.getInstance(event.target);
      if (popover) {
        popover.hide();
      }
    },
    shouldTruncate(label, text, minLength = 25) {
      const truncatableLabels = [
        'Use Case Location','Use Case','Process', 'Process Location', 'Sub Process', 'Sub Process Location', 'Input Node', 'Binding Node', 'Condition', 'Condition Group', 'Transition From', 'Transition To', 
        'Input', 'Output',  'Supporting Process Location', 'Supporting Process',  'Field Name', 'Reference Name', 'Expression', 'Reference Field Name', 'Process Name', 'Job Name'
      ];
      return truncatableLabels.includes(label) && text && text.length > minLength;
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) : text;
    },
    emitOpenMermaidChart(transaction) {
      const mermaidDiagram = transaction.diagram || transaction.diagramData;
      this.$emit("openMermaidChart", mermaidDiagram);
    },
    async fetchGraphData(transaction) {
      let graphType = 'MAPPER.USECASE_GRAPH';
      if (this.tableProps.type === 'mapper.Process_Details') {
        graphType = 'MAPPER.PROCESS_GRAPH';
      }
      const payload = {
        userId: getCookie(user.id),
        dataId: transaction.id,
        type: graphType,
      };
      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/graph_data", payload);
        if (response.status === 200) {
          this.$emit("openMermaidChart", response.data);
        } else {
          console.error("Failed to fetch graph data:", response);
        }
      } catch (error) {
        console.error("Error while fetching graph data:", error);
      }
    },

    async fetchChildActivities(processId) {
      // Check cache first
      if (this.childActivitiesCache[processId]) {
        const cached = this.childActivitiesCache[processId];
        return Array.isArray(cached) ? cached : [];
      }

      const payload = {
        userId: getCookie(user.id),
        processId: processId,
        type: "MAPPER.CHILD_ACTIVITIES",
      };

      this.showLoader = true;
      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/childActivities", payload);
        this.showLoader = false;
        // Extract activities array from response.data.data
        let activities = [];
        if (response.status === 200) {
          if (Array.isArray(response.data)) {
            activities = response.data;
          } else if (
            response.data &&
            Array.isArray(response.data.data)
          ) {
            activities = response.data.data;
          }
        }
        this.childActivitiesCache[processId] = activities;
        return activities;
      } catch (e) {
        console.error("Failed to fetch child activities", e);
        return [];
      }
    },
    async toggleChildTable(index) {
      if (this.openChildTableIndex === index) {
        this.openChildTableIndex = null;
      } else {
        const transaction = this.reportTransactions[index];
        const processId = transaction?.process?.id || transaction?.processId || transaction?.id;
        if (processId) {
          const activities = await this.fetchChildActivities(processId);
          if (!transaction.process) transaction.process = {};
          // Always assign an array
          transaction.process.activities = Array.isArray(activities) ? activities : [];
          if (typeof this.$set === "function") {
            this.$set(this.reportTransactions, index, { ...transaction });
          } else {
            this.reportTransactions = [...this.reportTransactions];
          }
        }
        this.openChildTableIndex = index;
      }
      this.$nextTick(() => {
        const child = this.$refs.childActivities?.[index];
        if (child && typeof child.toggleChildTable === "function") child.toggleChildTable();
      });
    },
    handleChildCollapse() {
      this.openChildTableIndex = null;
    },
    async childDownloadRowData(transaction) {
      console.log("Downloading row data for transaction:", transaction);
      
      let toastId = null;
      
      try {
        toastId = toast.loading("Processing download request...", {
          closeOnClick: false,
        });
        
        let payload = {
          userId: getCookie(user.id),
          jobId: transaction["Job Id"], // Use jobId if available, otherwise use transaction id
        };
        
        const initialResponse = await makeOpearationRequest(this.$acclConfigs, "/jobdownload", payload);
        
        if (initialResponse.status === 200 || initialResponse.status === 202) {
          const contentType = initialResponse.headers['content-type'];
          
          if (contentType && contentType.includes('application/json')) {
            const responseData = initialResponse.data;
            
            if (responseData.download_id && responseData.status === 'new') {
              toast.update(toastId, {
                render: `Download request accepted! Request ID: ${responseData.download_id}. ${responseData.message}`,
                type: "info",
                isLoading: false,
                autoClose: 5000,
              });
            } else {
              toast.update(toastId, {
                render: responseData.message || "Download request processed.",
                type: "info",
                isLoading: false,
                autoClose: 4000,
              });
            }
          } else {
            const blobConfig = {
              responseType: "blob",
            };
            
            const blobResponse = await makeOpearationRequest(this.$acclConfigs, "/jobdownload", payload, blobConfig);
            
            if (blobResponse.status === 200) {
              toast.update(toastId, {
                render: "Download completed successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
              });
              
              const blob = new Blob([blobResponse.data], { type: blobResponse.data.type });
              let fileName = "downloaded_file";
              const contentDisposition = blobResponse.headers['content-disposition'];
              if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                  fileName = fileNameMatch[1];
                }
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = changeFileExtension(fileName, "zip");
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            } else {
              toast.update(toastId, {
                render: "Download failed. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
              });
            }
          }
        } else {
          toast.update(toastId, {
            render: "Download failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to download row data:", initialResponse);
        }
      } catch (error) {
        if (toastId) {
          toast.update(toastId, {
            render: "Download request failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("Download request failed. Please try again.", {
            autoClose: 3000,
          });
        }
        console.error("Failed to download row data:", error);
      }
    },
    formatDateOnly(value) {
      if (!value || value === null) return "-";
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      // Use consistent MM/DD/YYYY format across all platforms
      return formatDateConsistent(date);
    },
    getSimplifiedAiEngine() {
      switch(this.aiOptions.aiEngine) {
        case "Claude Sonnet 4":
          return "claude";
        case "ChatGPT 4.1":
          return "chatgpt";
        default:
          return this.aiOptions.aiEngine.toLowerCase();
      }
    },
  },
  
};
</script>

<style scoped>
/* Checkbox styles */
.form-check-input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

/* Ensure proper alignment of checkboxes */
td.align-middle {
  vertical-align: middle !important;
}

/* Style for selected rows */
tr.custom-selected-row {
  background-color: #f0f7ff !important;
}

/* Media Query Start */

/* X-Small devices (portrait phones, less than 576px) */
/* No media query for `xs` since this is the default in Bootstrap */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {}

/* Medium devices (tablets, 768px and up) */
/* @media (min-width: 768px) {
  .filter-label{
    font-size: 15px;
    margin-top: 0px;
  }
 } */

/* Large devices (desktops, 992px and up) */
/* @media (min-width: 992px) { 
  .filter-label{
    font-size: 20px;
  }
 } */

/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {}

/* Media Query End */

/* Back Button Style Start */

.small-font {
  font-size: 0.7rem;
  margin-bottom: 0;
}

.back-button {
  margin-left: 15%;
  border-radius: 50% !important;
  background-color: rgba(255, 255, 255, 0.2);
  color: black;
  border: none !important;
  /* padding:  30px !important; */
  -webkit-transition: background-color 1s, color 1s, -webkit-transform 0.5s;
  transition: background-color 1s, transform 0.5s;
  box-shadow: 5px 0px 18px 0px rgba(105, 105, 105, 0.8);
}

.back-button:hover {
  -webkit-transform: translateX(-5px);
  transform: translateX(-5px);
}

.fa-3x {
  font-size: 2.5rem;
}

.sortbtn:hover,
.sortbtn {
  background-color: white;
  border-color: white;
  /* border-radius: 6px; */
  height: 5vh;
  width: 8vw;
  color: #da6a26;
  text-align: center;
  font-weight: bolder;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
  /* margin-left: 1rem; */
  /* margin-right: 12rem; */
}

.sortlbl {
  text-align: center;
  padding-top: 12px;
  padding-right: 3px;
  padding-left: 2px;
  padding-bottom: 8px;
}

.sortbtn.show {
  background-color: white;
  color: #da6a26;
}

.subitbtn {
  background-color: #da6a26;
  color: white;
  border: none;
  border-radius: 7px;
  height: 6vh;
  width: 10vw;
  text-align: center;
  font-weight: bolder;
}

.sort .sortbtn {
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
  margin-left: 1rem;
}

.sort {
  width: 22% !important;
  margin-left: 0.8rem;
  background-color: #da6a26;
  color: white;
  border: none;
  align-content: space-evenly;
  border-radius: 7px;
  text-align: left;
  text-justify: left;
  font-weight: bolder;
  /* height: 3vh; */
  /* width: 11vw; */
  float: left;
  padding: 0px 32px 0px 12px !important;
  /* margin-left: -2.5rem; */
}

.label {
  display: none;
  margin-left: 10px;
}

.xml-tranform-sidebar-menu {
  top: 35%;
}

.submitbtn {
  align-content: center;
}

.loading-gif {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  width: 130px;
}

.loading-gif img {
  max-width: 100%;
  /* Ensure the image scales properly */
  max-height: 100%;
  /* Ensure the image scales properly */
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

.right-margin {
  margin-right: 1rem;
}

.search-form {
  display: flex;
  align-items: center;
}

.col-sel-btn {
  margin-left: 0.2rem;
}

.constabtn {
  margin-left: 1%;
}

.empty {
  margin-right: -11rem;
}

.clrbtn {
  margin-left: 7rem;
  width: 7vw;
}


.cus-table-header-sticky {
  position: sticky;
  top: 0;
  right: 0;
  z-index: 1;
}

.table-header-sticky {
  height: 0%;
  top: 0;
  /* z-index: 1; */
  /* Ensures the header stays on top of other content */
}

/* diff container design start */
.diff-container {
  white-space: normal;
  margin-top: 20px;
}
.fileName-align {
  text-align: left;
}
.btn-mermaid {
cursor: pointer; 
 color: blue; 
 text-decoration: underline;
 font-size: inherit
}

/* table design start */

.custom-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border: 3px solid #ddd;
  border-radius: 8px;
  table-layout: auto;
}

.track-changes-table th {
  background-color: lightgrey;
  color: #000;
}

.custom-table th,
.custom-table td {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.nowrap {
  flex-wrap: nowrap;
  display: inline-flex;
}

.custom-table th {
  background-color: #da6a26;
  color: whitesmoke;
}

.table-responsive {
  position: relative;
  white-space: nowrap;
  font-size: 13px;
  margin-top: -25px;
}

table,
td {
  border: 1px;
}

th {
  border: 1px;
  cursor: pointer;
  position: relative;
}

.xml-tranfomer-dropdown-upload-icon {
  margin-left: 0px;
}

.xml-tranfomer-dropdown-para {
  margin-left: 10px;
}

.btn-view {
  background: url("@/assets/icons/view.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 26px;
  border: none;
}

.btn-download {
  background-repeat: no-repeat;
  font-size: 12px;
  /* Adjust this size as needed */
  margin-left: 5px;
  /* Space between icon and text */
  height: 26px;
  width: 26px;
  border: none;
}

.btn-show-difference {
  background: url("../../assets/icons/compare.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 26px;
  widows: 30px;
  border: none;
  object-fit: cover;
}

.btn-delete {
  background: url("../../assets/icons/delete-red2.svg");

  background-repeat: no-repeat;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 26px;
  border: none;
}

.btn-restore {
  background: url("../../assets/icons/restorebtn1.svg");

  background-repeat: no-repeat;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 26px;
  border: none;
}

.btn-ai {
  background: url("../../assets/icons/icons8-ai.svg");
  background-repeat: no-repeat;
  background-size: contain;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 25px;
  border: none;
  margin-top: -46px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-orchestration{
  background: url("../../assets/icons/orchestration4.png");
  background-repeat: no-repeat;
  background-size: contain;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 25px;
  border: none;
  margin-top: -46px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-ai:disabled,
.btn-ai.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  filter: grayscale(100%);
}

.btn-ai:hover:not(:disabled):not(.disabled) {
  filter: brightness(1.1);
  transform: scale(1.05);
}

.btn-trash {
  background: url("../../assets/icons/recycle-icon.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;

  font-size: 10px;
  margin-left: 5px;
  height: 20px;
  width: 20px;
  border: none;
}

.btn-transform {
  background: url("../../assets/icons/transform.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  /* Adjust this size as needed */
  margin-left: 5px;
  /* Space between icon and text */
  height: 26px;
  width: 26px;
  widows: 30px;
  border: none;
}

.btn-calculate {
  background: url("../../assets/icons/calculator-blue.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  /* Adjust this size as needed */
  margin-left: 5px;
  /* Space between icon and text */
  height: 26px;
  width: 26px;
  border: none;
}

.btn-download:disabled,
.btn-show-difference:disabled,
.btn-delete:disabled,
.btn-restore:disabled,
.btn-trash:disabled,
.btn-transform:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.t .button-group {
  height: 35px;
  float: left;
  margin: 10px;
}

.xml-tranfomer-dropdown {
  background: #666;
  height: 100px;
  width: 300px;
  border: #ccc;
}

.xml-tranfomer-dropdown img {
  height: 30%;
  width: 40%;
}

.container {
  max-width: 95%;
  margin-top: 100px;
}

.file-upload {
  width: 20%;
  height: 58vh;
  border: 2px dashed #333;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  float: left;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 8vw;
}

.mapper-view .report {
  width: 80%;
  height: 20vh;
  float: left;
}

.report {
  /* background: black; */
  /* border: 2px dashed #333;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
  /* transition: all 0.3s ease; */
  width: 80%;
  height: 70vh;
  float: left;
  /* background-color: #FFE8C8; */
}

.report-sub {
  margin-top: 5rem;
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
  height: 10vh;
  width: 90%;
  border: 2px dashed #333;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-left: 5%;
}

.table-custom tbody tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}

.table-custom tbody tr:nth-of-type(even) {
  background-color: #d9d9d9;
}

h1 {
  font-size: 3em;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 0.5em;
  margin-top: 1vh;
}

.h4 {
  font-size: 1.2em;
  font-weight: normal;
  color: #666;
  text-align: center;
  margin-bottom: 1em;
}

.file-upload-sub {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 8vw;
}

.file-upload:hover {
  border-color: #da6a26;
}

.file-upload input[type="file"] {
  display: none;
}

.file-upload button {
  filter: drop-shadow(0 15px 25px rgba(222, 98, 7, 0.15));
  display: inline-block;
  border: none;
  background: #da6a26;
  color: white;
  padding: 15px 40px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 50px;
  text-decoration: none;
  transition: background-color 0.3s ease;
  justify-content: center;
}

.file-upload button:disabled {
  background-color: #ccc;
  /* Change this to your preferred disabled color */
  cursor: not-allowed;
}

.file-upload button:hover {
  background-color: #333;
}

.file-upload ul {
  list-style-type: none;
  padding: 0;
  width: 100%;
}

.file-upload li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.file-upload li:hover {
  background-color: #f1f1f1;
}

.file-upload li button[title="Remove"] {
  background-color: #da6a26;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.file-upload li button[title="Remove"]:hover {
  background-color: #da6a26;
}

.file-upload p {
  color: #030a07;
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
}

nav {
  background-color: #cd7838;
  padding: 1em;
}

ul {
  list-style-type: none;
  padding: 0;
  overflow-y: scroll;
  max-height: 20rem;
}

li {
  /* display: inline; */
  /* margin-right: 1em; */
  margin-top: 1vh;
}

a {
  /* color: white; */
  text-decoration: none;
}

.sticky {
  position: sticky;
  right: 0;
  z-index: 0;
  width: 12%;
  box-shadow: 15px 0 15px -15px #da6a26, -9px 0 8px 0px #a9a9a9;
}

.scroll-class {
  /* height: min-content;
  overflow: scroll; */
  max-height: 150px;
  /* Set your desired max-height */
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 0;
  margin: 10px 0;
  list-style-type: none;
}

.scroll-class li {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
}

.srchip {
    height: 30px;
    width: 10vw !important;
    margin-top: -68px;
}

.searchbutton {
    height: 30px;
    padding: 2px;
    width: 70px;
    margin-top: -65px;
    margin-left: 5px;
}
.divalignleft {
  margin-left: -7rem;
}

.clrdiv {
  margin-left: -0.5rem;
}

.svg-button {
  /* margin-top: -1.5rem !important; */
  float: right;
  align-items: center;
  border: none;
  background-color: #da6a26;
  cursor: pointer;
  color: white;
}

.sort-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  display: flex;
  gap: 0.5em;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.2em;
  color: #aaa;
  user-select: none;
}

.clear-button:hover {
  color: #000;
}

.grayed-out {
  color: gray;
  opacity: 0.6;
}

.filter-icon-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.clear-filter-icon {
  margin-left: 10px;
  margin-right: 10px;
  border: none;
  background: unset;
  transform: translateX(-20px);
}

.clear-filter-icon:hover .filter-icon {
  filter: brightness(1.5);
  transform: scale(1.2);
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.5));
}

/**Styles for actionable and non actionable columns */
.text-success {
  transition: font-size 0.3s ease;
}

.text-danger {
  transition: font-size 0.3s ease;
}

.text-new-status {
  color: #1d2856;
  transition: font-size 0.3s ease;
}

.text-in-progress {
  color: #cd7838;
  transition: font-size 0.3s ease;
}

.text-not-applicable {
  color: #2b3b78;
  transition: font-size 0.3s ease;
}

.actionable:hover {
  font-size: 1.1em;
  text-decoration: underline;
  cursor: pointer;
}

.dropdown-item {
  line-height: 1.4;
}

.getOverrideCssClass {
  text-align: left;
}

.actions-dropdown-toggle {
  background: url("../../assets/icons/menu.svg") no-repeat center center;
  background-size: contain;
  cursor: pointer;
  outline: none;
  transition: background-image 0.3s ease;
  height: 26px;
  width: 26px;
  border: none;
}

.actions-dropdown-toggle.show {
  background-image: url("../../assets/icons/menu_open.svg");
  transform: rotate(90deg);
}

.icon-row {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}

/* Icon style */
.icon {
  width: 24px;
  height: 24px;
}

.gloss-view-content {
  text-align: center;
  display: grid;
}

.code-editor {
  width: 50%;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px;
  font-family: monospace;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.code-content {
  white-space: pre-wrap;
  overflow: auto;
  max-height: 300px;
  max-width: fit-content;
  background-color: #dbd8d6;
  color: black;
  padding:  10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  display: inline-block;
}

.toolbar {
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
}

.separator {
  height: 2px;
  background-color: #ccc;
  margin: 16px 0;
}

.submit-wrapper {
  margin-left: auto;
}

.submit-button {
  padding: 10px 16px;
  background-color: #da6a26;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #f16915;
}

.discard-button {
  padding: 10px 16px;
  background-color: #dc3545;
  /* Bootstrap danger color */
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.discard-button:hover {
  background-color: #c82333;
  /* Darker red on hover */
}

.editable-icon {
  background-image: url("../../assets/icons/editable.svg");
  background-repeat: no-repeat;
  background-position: right;
  cursor: pointer;
}

select {
  border: 1px solid #ccc;
  /* Border color */
  border-radius: 9px;
  /* Rounded corners */
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
}

select:focus {
  outline: none;
  /* Remove outline */
  box-shadow: 0 0 5px rgba(255, 179, 0, 0.676);
  /* Box shadow on focus */
}

.download-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: #1D2856 !important;
  margin-right: 5px;
  margin-top: -48px;
  font-size: 20px;
  height: 30px;
}
.download-button:hover {
  filter: brightness(1.5);
  transform: scale(1.2);
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.5));
}
.filter-icon-button{
  color: #1D2856 !important;
  margin-right: -28px;
  margin-top: -65px;
}
.column-button {
  background-color: #1D2856 !important;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  margin-top: -48px;
  margin-right: 10px;
  background-color: #1D2856 !important;
  font-size: 12px;
  height: 30px;
  border-radius: 5px;
}
.allCategories {
  background-color: #1D2856 !important;
  font-size: 12px;
  height: 30px;
  border-radius: 5px;
  margin-top: -48px;
}
.search-form1{
  margin-top: -51px;
  height: 30px;
}

.btn-eye {
  background: url("../../assets/icons/eye-close.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 26px;
  border: none;
  cursor: pointer;
  margin-right: 5px;
  margin-top: -45px;
}

.btn-eye:hover {
  filter: brightness(1.5);
  transform: scale(1.2);
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.5));
}

.full-height {
  height: calc(100vh - 150px); /* Adjust the 100px to match the height of your header and footer */
  overflow-y: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ai-modal-content {
  background: white;
  padding: 0;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.25rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 15px;
  margin-top: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: #f0f0f0;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin-bottom: 20px;
  color: #666;
}

.selected-items {
  margin-bottom: 20px;
}

.selected-items h4 {
  margin-bottom: 10px;
  color: #333;
  font-size: 1rem;
}

.no-selection {
  padding: 15px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  margin-bottom: 15px;
}

.warning-text {
  color: #856404;
  margin: 0;
  font-weight: 500;
}

.selection-list ul {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  margin: 0;
  background-color: #f8f9fa;
}

.selection-list li {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  color: #333;
}

.selection-list li:last-child {
  border-bottom: none;
}

.more-items {
  font-style: italic;
  color: #666;
}

.options-section {
  margin-bottom: 15px;
}

.options-section h4 {
  margin-bottom: 8px;
  color: #333;
  font-size: 1rem;
}

.checkbox-group {
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  font-weight: normal;
}

.checkbox-group input[type="checkbox"] {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.radio-group {
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  display: flex;
  flex-direction: row;
  gap: 45px;
  align-items: center;
}

.radio-group h4 {
  margin: 0;
  margin-right: 10px;
  color: #333;
  font-size: 1rem;
  align-self: center;
  min-width: 80px;
}

.radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  font-weight: normal;
  transition: opacity 0.2s;
}

.radio-label.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.radio-label input[type="radio"] {
  margin-right: 6px;
  width: 16px;
  height: 16px;
  cursor: inherit;
}

.radio-label input[type="radio"]:disabled {
  cursor: not-allowed;
}

.radio-text {
  cursor: inherit;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
  background-color: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

.btn-cancel {
  padding: 8px 16px;
  background-color: #856404;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.btn-cancel:hover {
  background-color: #5a6268;
}

.btn-generate {
  padding: 8px 16px;
  background-color: #856404;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.btn-generate:hover:not(.disabled) {
  background-color: #c55a1e;
}

.btn-generate.disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 40%;
  width: 100%;
  text-align: center;
  font-size: x-small;
}

.expand-icon-fixed {
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Questions section styles */
.questions-section {
  margin-top: 20px;
}

.questions-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 10px;
}

.questions-table th,
.questions-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.questions-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  font-size: 11px;
}

.questions-table td:first-child {
  width: 70%;
  font-size: 11px;
  text-align: left;
}

.questions-table td:nth-child(2) {
  width: 120px;
}

.radio-options {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  cursor: pointer;
  margin: 0;
}

.radio-option input[type="radio"] {
  margin: 0;
  width: 12px;
  height: 12px;
}

.radio-option span {
  font-size: 10px;
  line-height: 1;
}

/* Override modal max-width for orchestration popup */
.ai-modal-content {
  max-width: 800px;
  width: 90%;
}
</style>



